import React from "react";
import "./index.css";
import AuthRoute from "./routes";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";

const App: React.FC = () => {

  return (
    <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
      <AuthRoute />
    </MsalAuthenticationTemplate>
  )
};

export default App;
